import { z } from 'zod';
/** A phone attempt is ended only after the server confirms its durable/provider outcome. */
export const voiceAttemptCancellationResponseSchema = z.object({
    success: z.literal(true),
    ended: z.literal(true)
}).strict();
/** A VCO speaking acknowledgment names the granted participant and confirmed state. */
export const vcoSpeakingResponseSchema = z.object({
    success: z.literal(true),
    speaking: z.boolean(),
    participantCallSid: z.string().regex(/^CA[0-9a-fA-F]{32}$/).optional(),
    muted: z.boolean(),
    conferenceName: z.string().min(1).max(128),
    identity: z.string().min(1).max(121)
});
